var _defs, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParticipants(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "IMGs",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#474749;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 16,
    cy: 16,
    r: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.84,16c1.57,0,2.84-1.27,2.84-2.84s-1.27-2.84-2.84-2.84c-.64,0-1.22,.22-1.69,.57,.29,.56,.48,1.19,.48,1.87,0,.9-.3,1.73-.8,2.4,.52,.52,1.23,.85,2.02,.85Zm1.2,1.62h-1.88c1.17,.96,1.9,2.39,1.9,3.99,0,.32-.1,.62-.25,.88h3.5c.45,0,.81-.37,.81-.84,0-2.22-1.82-4.04-4.09-4.04Zm-5.19-.41h-2.57c-2.43,0-4.4,1.97-4.4,4.4,0,.49,.39,.88,.88,.88h9.61c.49,0,.88-.39,.88-.88,0-2.43-1.97-4.4-4.4-4.4Zm-1.29-1.22c1.8,0,3.25-1.46,3.25-3.25s-1.45-3.25-3.25-3.25-3.25,1.46-3.25,3.25,1.45,3.25,3.25,3.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipants);
export default __webpack_public_path__ + "static/media/participants.1484f05a04b761734fff571c468f9a56.svg";
export { ForwardRef as ReactComponent };